// Libraries
import React from 'react';

// Supermove
import {UrlFiltersType} from '@supermove/hooks';

// App
import ViewProjectJobs from 'modules/Project/V2/Show/components/ViewProjectJobs';
import {ProjectPageUrlFiltersType} from 'modules/Project/V2/types/ProjectPageUrlFilters';

const JobsWidget = ({
  urlFilters,
  projectUuid,
}: {
  urlFilters: UrlFiltersType<ProjectPageUrlFiltersType>;
  projectUuid: string;
}) => {
  return <ViewProjectJobs urlFilters={urlFilters} projectUuid={projectUuid} isWidget />;
};

export default JobsWidget;
